import  { useState, createContext, useContext } from "react";
import * as Atoms from "data/Atoms";
import { useRecoilState } from "recoil";

const MapContext = createContext();

export const MapContextProvider = ({ children }) => {
  const [showData, setShowData] = useState(false);
  const [dataType, setDataType] = useState(null);
  const [step, setStep] = useState(null);
  const [selectedParcelsData, setSelectedParcelsData] = useRecoilState(
    Atoms.selectedParcelsData
  );
  const [selectedUnitsGroup, setSelectedUnitsGroup] = useRecoilState(
    Atoms.selectedUnitsGroup
  );
  const [selectedIds, setSelectedIds] = useState([]);
  const [parcelsCentroidsSelected, setParcelsCentroidsSelected] = useState([]);
  const [selectedUnitsGroupIds, setSelectedUnitsGroupIds] = useState([]);
  const [unitsGroupCentroidsSelected, setUnitsGroupCentroidsSelected] =
    useState([]);
  const [mapColorType, setMapColorType] = useState(0);
  const [mapLevel, setMapLevel] = useState(1);
  const [mapFilterSelected, setMapFilterSelected] = useState("units");
  const [batchUnitSelected, setBatchUnitSelected] = useState("units");
  const [parcelsPricePerMeter, setParcelsPricePerMeter] = useState({});
  const [parcelsPriceTotal, setParcelsPriceTotal] = useState({});
  const [parcelsAdNumbers, setParcelsAdNumbers] = useState({});
  const [parcelsAdNumbersVerified, setParcelsAdNumbersVerified] = useState({});

  const clearMapData = () => {
    setSelectedParcelsData([]);
    setSelectedIds([]);
    setParcelsCentroidsSelected([]);
    setSelectedUnitsGroup([]);
    setSelectedUnitsGroupIds([]);
    setUnitsGroupCentroidsSelected([]);
    setParcelsPricePerMeter({});
    setParcelsPriceTotal({});
    setParcelsAdNumbers({});
    setParcelsAdNumbersVerified({});
  };

  const clearMapDataAndColor = () => {
    setShowData(false);
    setDataType(null);
    setStep(null);
    setMapColorType(0);
    clearMapData();
  };

  return (
    <MapContext.Provider
      value={{
        mapColorType,
        setMapColorType,
        mapFilterSelected,
        setMapFilterSelected,
        showData,
        setShowData,
        dataType,
        setDataType,
        step,
        setStep,
        selectedParcelsData,
        setSelectedParcelsData,
        selectedUnitsGroup,
        setSelectedUnitsGroup,
        selectedIds,
        setSelectedIds,
        parcelsCentroidsSelected,
        setParcelsCentroidsSelected,
        selectedUnitsGroupIds,
        setSelectedUnitsGroupIds,
        unitsGroupCentroidsSelected,
        setUnitsGroupCentroidsSelected,
        batchUnitSelected,
        setBatchUnitSelected,
        parcelsPricePerMeter,
        setParcelsPricePerMeter,
        parcelsPriceTotal,
        setParcelsPriceTotal,
        parcelsAdNumbers,
        setParcelsAdNumbers,
        parcelsAdNumbersVerified,
        setParcelsAdNumbersVerified,
        mapLevel,
        setMapLevel,
        clearMapData,
        clearMapDataAndColor,
      }}
    >
      {children}
    </MapContext.Provider>
  );
};

export const useMapContext = () => {
  return useContext(MapContext);
};
